import { motion } from "framer-motion";
import { Button } from "../components/ui/button";
import { ArrowRight } from "lucide-react";

const WhyChooseUs = () => {
  const targets = [
    "Property developers",
    "Landowners and investors",
    "Residential, commercial and industrial developments",
    "Housing and mixed-use development projects",
    "Municipalities and public institutions",
    "Mining and commercial operators",
    "Companies, trusts and investment structures",
    "Professional teams requiring specialist conveyancing support",
  ];

  const scrollToSection = (href) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <>
      {/* Who We Serve */}
      <section id="why-us" className="bg-light-grey py-24 lg:py-32" data-testid="why-choose-us-section">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-16 items-start">
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
            >
              <p className="uppercase tracking-[0.2em] text-xs font-bold text-brand-gold mb-4">
                Target Market
              </p>
              <h2 className="font-serif text-4xl sm:text-5xl font-semibold text-charcoal leading-tight tracking-tighter mb-6">
                Who We Serve
              </h2>
              <p className="text-charcoal/60 font-sans text-lg leading-relaxed">
                Our clients are those who need specialist legal insight for property developments, investment transactions and commercial operations that demand more than general legal advice.
              </p>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.2 }}
              className="grid sm:grid-cols-2 gap-3 sm:gap-4"
            >
              {targets.map((item, index) => (
                <div
                  key={index}
                  className="flex items-start p-4 bg-white border border-charcoal/10 hover:border-brand-gold/30 transition-colors"
                >
                  <div className="w-2 h-2 bg-brand-gold mt-1.5 mr-3 flex-shrink-0" />
                  <span className="text-charcoal/80 font-sans text-sm">{item}</span>
                </div>
              ))}
            </motion.div>
          </div>
        </div>
      </section>

      {/* Closing CTA */}
      <section className="bg-charcoal py-24 lg:py-32">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-semibold text-white leading-tight tracking-tighter mb-6">
              Development Requires More Than a Transfer Attorney
            </h2>
            <p className="text-white/60 font-sans text-base sm:text-lg leading-relaxed mb-4 max-w-2xl mx-auto">
              It requires legal professionals who understand how land, registered rights, commercial agreements, regulatory processes and stakeholder relationships must work together.
            </p>
            <p className="text-white/50 font-sans text-sm sm:text-base leading-relaxed mb-8 sm:mb-10 max-w-2xl mx-auto">
              Mheshe Attorneys provides the specialist legal and conveyancing insight needed to move property developments from concept to registration.
            </p>
            <div className="flex flex-col sm:flex-row justify-center gap-4">
              <Button
                onClick={() => scrollToSection("#lead-capture")}
                className="btn-gold px-8 py-4 text-base font-semibold uppercase tracking-wider rounded-none"
                data-testid="closing-cta-btn"
              >
                Discuss Your Development
              </Button>
              <button
                onClick={() => scrollToSection("#contact")}
                className="text-brand-gold hover:text-white border-b border-brand-gold/50 hover:border-white pb-1 text-sm font-semibold uppercase tracking-wider transition-colors"
              >
                Contact Our Team
              </button>
            </div>
          </motion.div>
        </div>
      </section>
    </>
  );
};

export default WhyChooseUs;
